import type { CMSSystemInfoReply } from '@/types/common/system'
import { getDomainUrl, setFavicon, setPageTitle } from '@/store/tool'
import { systemInfo } from '@/api/common'
import { cacheStoreInLocal, getCacheStoreFromLocal } from '@/store/local'
import { useElementLocal } from '@/hooks/useElementLocal'
const actions = {
  async getSystemInfo({ commit }: { commit: any }): Promise<void> {
    const res = await systemInfo({ domain: getDomainUrl() })
    const info: CMSSystemInfoReply = {
      ...res,
    }

    commit('SET_SYSTEM_INFO', info)
    setFavicon(info.logoIcon)
    setPageTitle(info.loginTitle)
    const lang = info.inChina ? 'zh_cn' : 'en'
    commit('SET_LANGUAGE', lang, { root: true })
    // localStorage.setItem('language', lang)
  },
}

const mutations = {
  SET_SYSTEM_INFO: (
    state: { systemInfo: CMSSystemInfoReply },
    systemInfo: CMSSystemInfoReply,
  ): void => {
    state.systemInfo = systemInfo
    cacheStoreInLocal('cms', 'systemInfo', systemInfo)
  },
}
const state = {
  systemInfo: getCacheStoreFromLocal('cms', 'systemInfo', <CMSSystemInfoReply>{}),
}
const getters = {
  systemInfo: (state: { systemInfo: CMSSystemInfoReply }): CMSSystemInfoReply => state.systemInfo,
}
export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
}
